<template>
    <div class="col-md-12">
        <div class="col-md-12 mt-20">
            <div class="col-md-12 row">
                <div class="col-md-9">
                    <h3 class="page-header">
                        <i class="fa fa fa-building animated bounceInDown show-info" style="font-size: 24px;"></i>
                        <span class="animated bounceInDown">Furniture Category</span>
                    </h3>
                </div>
            </div>
        </div>
        <div>
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-4">
                        <label>Sub Category</label>
                        <input type="text" class="form-control" v-model="subcategoryname" />
                    </div>
                    <div class="col-md-3 mt5">
                        <button class="btn btn-success mt-20" @click="addSubCategory()">Save</button>
                        <button class="btn btn-danger mt-20 ml-5" @click="cancel()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-10">
            <table class="table">
                <thead>
                    <th>#</th>
                    <th>Category Name</th>
                    <th>Action</th>
                </thead>
                <tbody>
                    <tr v-for="(category, index) in categories" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ category.name }}</td>
                        <td>
                            <button class="btn btn-primary" @click="editCategory(category)">Edit</button>
                            <button class="btn btn-danger btn-sm" @click="deleteCategory(category)">Delete</button> 
                        </td>
                       
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Constants from '../../components/utilities/Constants.vue';
import { mapGetters } from "vuex";

export default {
    mixins: [Constants],
    data() {
        return {
            subcategoryname: '',
            searchtext: '',
            category:null,
            categories: [],
            id: 0,
        }
    },
    mounted() {
        if(this.furniturecategory == null) {
            this.$store.dispatch('fetchFurnitureCategory');
        }else {
            this.category = this.furniturecategory;
        }
        this.initialize();
    },
    watch:{
        furniturecategory: function(newVal) {
            if (newVal != null) {
                this.category = newVal;
            }
        },
    },
    computed: {
        ...mapGetters(['furniturecategory']),
    },
    methods: {
        
        initialize(){
            setTimeout(() => {
                this.refresh();
            }, 1000);
        },
        refresh() {
           axios.post('api/category/by/parentid',{parent_id: this.category?.id})
                .then((response) => {
                    this.categories = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        
        addSubCategory() {
            if (this.subcategoryname == '') {
                this.showError('Please enter sub category name');
                return;
            }
            let data = {
                id: this.id,
                name: this.subcategoryname,
                parent_id: this.category?.id
            }
            axios.post('api/category/createupdate', data)
                .then((response) => {
                    console.log(response);
                    this.cancel()
                    
                })
                .catch((error) => {
                    console.log(error);
                    this.showError('Failed to add sub category');
                });
        },
        cancel() {
            this.id = 0;
            this.subcategoryname = '';
            this.refresh();
        },
        editCategory(item) {
            this.id = item.id;
            this.subcategoryname = item.name;
                      
        },
        deleteCategory(item) {
            if (confirm('Are you sure you want to delete this sub category?')) {
                axios.post('api/category/updateactive', { id: item.id, active: 0 })
                    .then((response) => {
                        console.log(response.data);
                        this.refresh();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showError('Failed to delete sub category');
                    });
            }
        },

    },
}
</script>